export const SERVICE_LINES = {
    custom_software_development: 'Custom Software Development',
    ecommerce: 'E-Commerce',
    ai_automation: 'AI & Automation',
    mobile_app_development: 'Mobile App Development',
    system_integration: 'System Integration',
    data_pim_services: 'Data & PIM Services',
    cloud_devops: 'Cloud & DevOps',
    app_modernization_migration: 'Application Modernization & Migration',
    managed_support_maintenance: 'Managed Support & Maintenance',
    staff_augmentation: 'Staff Augmentation',
    consulting_discovery: 'Consulting & Discovery',
    saas_bezohminds_products: 'SaaS / Bezohminds Products',
};

export const SERVICE_LINE_ORDER = Object.keys(SERVICE_LINES);

/** Legacy keys from earlier builds — display-friendly fallback */
const LEGACY_SERVICE_LINE_LABELS = {
    web_development: 'Web Development',
    mobile_development: 'Mobile Development',
    software_as_a_service: 'Software as a Service',
    system_migration: 'System Migration',
    consulting: 'Consulting',
};

export function getServiceLineLabel(key) {
    return SERVICE_LINES[key] || LEGACY_SERVICE_LINE_LABELS[key] || key;
}

export function getServiceLinesForPipeline(pipelineKey) {
    return SERVICE_LINE_ORDER;
}

/**
 * Parse a service_line value from the DB/API.
 * Handles: JSON array string, comma-separated legacy string, or plain single key.
 * Always returns an array of keys.
 */
export function parseServiceLines(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    const str = String(raw).trim();
    if (str.startsWith('[')) {
        try {
            const parsed = JSON.parse(str);
            return Array.isArray(parsed) ? parsed : [str];
        } catch {
            // fall through to comma-separated
        }
    }
    if (str.includes(',')) {
        return str.split(',').map(s => s.trim()).filter(Boolean);
    }
    return str ? [str] : [];
}

/**
 * Serialize an array of service line keys to a JSON string for storage.
 * If given an empty array, returns null.
 */
export function serializeServiceLines(arr) {
    if (!arr || arr.length === 0) return null;
    if (arr.length === 1) return arr[0];
    return JSON.stringify(arr);
}
